// @flow strict
import * as React from "react"
import ThemeProvider from "@kiwicom/orbit-components/lib/ThemeProvider"
import * as R from "ramda"
import { getBrandTheme } from "@kiwicom/nitro/lib/records/Theme"
import { Provider as BrandProvider } from "@kiwicom/nitro/lib/services/brand/context"
import type { Brand } from "@kiwicom/nitro/lib/records/Brand"
import type { Session } from "@kiwicom/nitro/lib/records/Session"
import type { IntlRaw } from "@kiwicom/nitro/lib/records/Intl"
import type { Translations } from "@kiwicom/orbit-components/lib/Dictionary"
import { Provider as FetchedProvider } from "@kiwicom/nitro/lib/services/fetched/context"
import type { Fetched } from "@kiwicom/nitro/lib/records/Fetched"
import { Provider as LogProvider } from "@kiwicom/nitro/lib/services/log/context"
import { brandDefault } from "@kiwicom/nitro/lib/records/Brand"

import cuckoo from "../../services/cuckoo/cuckoo"
import NitroBridge from "../NitroBridge"
import getFontFamilyFromLanguage from "../../utils/getFontFamilyFromLanguage"

type Props = {|
  brand: Brand,
  intl: IntlRaw,
  fetched: Fetched,
  session: Session,
  children: React.Node,
  orbit: {
    dictionary: Translations,
  },
|}

// TODO
// Hotfix, remove ASAP
// eslint-disable-next-line camelcase
// $FlowFixMe: error revealed by updating Flow and Ramda libdef, please fix
const TMP_kiwiFallback = R.over(
  R.lensPath(["theme", "palette"]),
  R.defaultTo(brandDefault.theme.palette),
)

const NitroProvider = ({ brand, intl, fetched, session, children, orbit }: Props) => {
  const tmpTokens = getBrandTheme(TMP_kiwiFallback(brand), intl.language.direction === "rtl")
  const tokens = {
    ...tmpTokens,
    orbit: {
      ...tmpTokens.orbit,
      fontFamily: getFontFamilyFromLanguage({ language: intl.language }),
    },
  }

  return (
    <NitroBridge intl={intl} session={session}>
      {/* $FlowExpected - styled components theme provider is a lil fucked up */}
      <ThemeProvider theme={tokens} dictionary={orbit.dictionary}>
        <BrandProvider value={brand}>
          <FetchedProvider value={fetched}>
            <LogProvider value={{ log: (e, p) => cuckoo.nitro(e, p) }}>{children}</LogProvider>
          </FetchedProvider>
        </BrandProvider>
      </ThemeProvider>
    </NitroBridge>
  )
}

export default NitroProvider
